


import { useState, useEffect, useRef } from 'react'
import './admin.css'

import { auth, db } from '../../firebaseConnection'
import { signOut, deleteUser, getAuth } from 'firebase/auth'

import { Link } from 'react-router-dom'

import moment from 'moment'


import {
  addDoc,
  collection,
  onSnapshot,
  query,
  orderBy,
  where,
  doc,
  deleteDoc,
  updateDoc
} from 'firebase/firestore'


export default function Admin() {
  const [clienteInput, setClienteInput] = useState('')
  const [dateInput, setDateInput] = useState(new Date())
  const [horaInput, setHoraInput] = useState('')
  const [servicoInput, setServicoInput] = useState('')
  const [priceInput, setPriceInput] = useState('')
  const [user, setUser] = useState({})
  const [edit, setEdit] = useState({})
  const [agenda, setAgenda] = useState([]);

  const formRef = useRef(null);


  useEffect(() => {
    async function loadAgenda() {
      const userDetail = localStorage.getItem("@detailUser")
      setUser(JSON.parse(userDetail))

      if (userDetail) {
        const data = JSON.parse(userDetail);

        const agendaRef = collection(db, "agenda")
        const q = query(agendaRef, orderBy("data", 'asc'), orderBy("hora", 'asc'), where('userUid', '==', data?.uid))

        const unsub = onSnapshot(q, (snapshot) => {
          let lista = [];

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              cliente: doc.data().cliente,
              data: doc.data().data,
              hora: doc.data().hora,
              servico: doc.data().servico,
              price: doc.data().price,
              userUid: doc.data().userUid,
              finalizado: doc.data().finalizado || false // Adicionando o estado do checkbox
            })
          })

          setAgenda(lista);
        })
      }
    }

    loadAgenda();
  }, [])

  async function handleRegister(e) {
    e.preventDefault();

    if (clienteInput === '' || dateInput === '' || horaInput === '' || servicoInput === '') {
      alert("Preencha todo o agendamento...")
      return;
    }

    if (edit?.id) {
      handleUpdateAgenda();
      return;
    }

    await addDoc(collection(db, "agenda"), {
      cliente: clienteInput,
      data: dateInput,
      hora: horaInput,
      servico: servicoInput,
      price: priceInput,
      userUid: user?.uid,
      finalizado: false // Estado inicial do checkbox
    })
      .then(() => {
        setClienteInput('')
        setDateInput('')
        setHoraInput('')
        setServicoInput('')
        setPriceInput('')
      })
      .catch((error) => {
        console.log("Erro ao registrar agendamento")
      })
  }

  async function handleLogout() {
    await signOut(auth);
  }

  async function deleteCliente(id) {
    const docRef = doc(db, "agenda", id)
    await deleteDoc(docRef)
  }

  async function editCliente(item) {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });

    }
    setClienteInput(item.cliente)
    setDateInput(item.data)
    setHoraInput(item.hora)
    setServicoInput(item.servico)
    setPriceInput(item.price)
    setEdit(item)
  }

  async function handleUpdateAgenda() {
    const docRef = doc(db, "agenda", edit?.id)
    await updateDoc(docRef, {
      cliente: clienteInput,
      data: dateInput,
      hora: horaInput,
      servico: servicoInput,
      price: priceInput
    })
      .then(() => {
        setClienteInput('')
        setDateInput('')
        setHoraInput('')
        setServicoInput('')
        setPriceInput('')
        setEdit({})
      })
      .catch(() => {
        setClienteInput('')
        setEdit({})
      })
  }

  async function toggleCheckbox(id, isChecked) {
    const docRef = doc(db, "agenda", id)
    await updateDoc(docRef, {
      finalizado: isChecked
    })
  }

  //Formata a data para o padrão Br
  moment.locale('pt-br');
  const formato = 'DD/MM/YYYY';



  function confirmDelete() {
    const message = `Tem certeza que quer deletar a conta? Não pode ter nenhum agendamento`;
    // chamando o método window.confirm() com a mensagem
    const confirmation = window.confirm(message);
    // verificando o valor de retorno do método
    if (confirmation) {
      // se o usuário clicou em OK, chamando a função deleteUser com o ID do usuário
      deleteAccount();
    } else {
      // se o usuário clicou em Cancelar, mostrando uma mensagem de cancelamento
      console.log("Deleção cancelada pelo usuário.");
    }
  }

  async function deleteAccount() {
    const auth = getAuth();
    const user = auth.currentUser;

    deleteUser(user).then(() => {
      <Link to='admin' />
      alert("Conta excluida com sucesso!")
    }).catch((error) => {
      // An error ocurred
      // ...
    });
  }

  return (
    <div className='admin-container'>
      <button className='btn-delete-account' onClick={confirmDelete}>Excluir minha conta</button>

      <h1>Meus agendamentos</h1>


      <form ref={formRef} className='form' onSubmit={handleRegister}>
        <input
          type='text'
          placeholder='Digite o nome da(o) cliente'
          value={clienteInput}
          onChange={(e) => setClienteInput(e.target.value)}
        />

        <label>Escolha a data</label>
        <input
          type='date'
          placeholder='Digite a data'
          value={dateInput}
          onChange={(e) => setDateInput(e.target.value)}
        />

        <label>Escolha o horário</label>
        <input
          type='time'
          placeholder='Digite o horário'
          value={horaInput}
          onChange={(e) => setHoraInput(e.target.value)}
        />

        <input
          type='text'
          placeholder='Qual o serviço a ser feito?'
          value={servicoInput}
          onChange={(e) => setServicoInput(e.target.value)}
        />

        <input
          type='number'
          placeholder='Qual o preço do serviço? (opcional)'
          value={priceInput}
          onChange={(e) => setPriceInput(e.target.value)}
        />

        {Object.keys(edit).length > 0 ? (
          <button className='btn-register' type='submit'>Atualizar agendamento</button>
        ) : (
          <button className='btn-register' type='submit'>Resgistrar agendamento</button>
        )}
      </form>

      <button className='btn-logout' onClick={handleLogout}>Sair</button>

      {agenda.map((item) => (
        <article key={item.id} className='list'>
          <p className='day'>Dia: {moment(item.data).format(formato)}</p>
          <p>Cliente: {item.cliente}</p>
          <p>Horário: {item.hora}</p>
          <p>Serviço: {item.servico}</p>

          {item.price !== '' &&
            <p>Preço: R$ {item.price}</p>
          }

          <div className='btn-agendamentos'>
            <button onClick={() => editCliente(item)} className='btn-editar'>Editar</button>
            <button onClick={() => deleteCliente(item.id)} className='btn-delete'>Excluir</button>
            <input
              type='checkbox'
              className='checkbox'
              checked={item.finalizado}
              onChange={(e) => toggleCheckbox(item.id, e.target.checked)}
            /> Finalizado
          </div>
        </article>

      ))}


    </div>
  )
}